import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { useToast } from '@/hooks/use-toast';
import { Loader2 } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.company_email, form.password);
      toast({ title: 'Welcome back', description: u.name });
      navigate(u.role === 'partner' ? '/partner/dashboard' : '/dashboard');
    } catch (err) {
      toast({ title: 'Login failed', description: err?.response?.data?.detail || 'Try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-[80vh] flex items-center">
      <div className="absolute inset-0 viso-grid opacity-30" />
      <div className="relative w-full max-w-md mx-auto px-6">
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-8">
          <div className="text-xs font-mono uppercase tracking-widest text-cyan-300 mb-3">Sign in</div>
          <h1 className="font-display text-3xl font-bold">Welcome back to Visotonics</h1>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-slate-300">Company email</Label>
              <Input type="email" required value={form.company_email} onChange={(e) => setForm({ ...form, company_email: e.target.value })} className="bg-black/30 border-white/10 mt-1" />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label className="text-slate-300">Password</Label>
                <Link to="/forgot-password" className="text-xs text-cyan-300 hover:text-cyan-200">Forgot password?</Link>
              </div>
              <Input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="bg-black/30 border-white/10 mt-1" />
            </div>
            <Button disabled={loading} className="w-full bg-cyan-400 hover:bg-cyan-300 text-slate-900 font-medium">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Log in
            </Button>
          </form>
          <div className="mt-6 text-sm text-slate-400 flex justify-between">
            <Link to="/register" className="hover:text-cyan-300">Create account</Link>
            <Link to="/partner/register" className="hover:text-cyan-300">Partner registration</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
